import { render, staticRenderFns } from "./room-type-card.vue?vue&type=template&id=0c8ff9b0"
import script from "./room-type-card.vue?vue&type=script&lang=js"
export * from "./room-type-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports